
import Header from "../Common/Header";
import Footer from "../Common/Footer";
function Wallet() {
  return (
   <>
   <Header />
    {/* Start Our Features area */}
    <div className="features-area pt-100 pb-70 bgcolor">
      <div className="container">
        <div className="section-title">
          
          <h2>Wallet Services</h2>
        </div>
     
        <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div class="section-title leftalign">
            
        <span className="">Wallet Services
        </span>
          </div>
          </div>

          </div>
          <div className="row parent">
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/payment.svg"  />
                            </div>
                            <h3>AePS
                            </h3>
                        </div>
                        <p>Aadhaar Enabled Payment System (AePS)



</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>


          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/bharat-pay.svg"  />
                            </div>
                            <h3>BBPS

                            </h3>
                        </div>
                        <p>Pay Bills On Bharat Bill Payment System


                        </p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>

</div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/recharge.svg"  />
                            </div>
                            <h3>Recharges
                            </h3>
                        </div>
                        <p>Fast & easy mobile recharge online

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/home-loan.svg"  />
                            </div>
                            <h3>DMT
                            </h3>
                        </div>
                        <p>Send money to your loved ones instantly</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          
</div>
          </div>



        </div>

      </div>
    </div>
    {/* End Our Features area */}
  
    <Footer />
   </>
  );
}

export default Wallet;
